import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, throwError, Observable } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';

// INTERFACES
import { IApprovalRule } from '../../../../approval/interfaces';
import { IPagination } from '../../../interfaces/paginator.interface';

// SERVICES
import { EnvironmentUtilService } from '../../util';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class ApprovalRuleApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  delete(id :number) :Observable<any> {
    return this.apiService.delete(`${this.environment.urlV2}/approval-rules/${id}`);
  }

  update(
    id :number,
    data :{ [param :string] :string | string[] },
  ) :Observable<any> {
    return this.apiService.put(
      `${this.environment.urlV2}/approval-rules/${id}`,
      data,
    );
  }

  create(data :{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/approval-rules`,
      body: data,
    });
  }

  get(params ?:{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV2}/approval-rules`, {
      params,
    });
  }

  getById(
    id :number,
    params ?:{ [param :string] :string | string[] },
  ) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV2}/approval-rules/${id}`, {
      params,
    });
  }
}
